import Sjcl from '@cryptolize/sjcl'

/**
 * Derives encryption key from simple text
 *
 * @param {String} password
 * @param {Object} $1 derivation params
 * @param {Base64UrlString} $1.salt
 * @param {Number} $1.iterations
 * @return {Base64UrlString}
 * @throws {Error} if a parameter is invalid
 * @public
 */
export function deriveKey (password, { salt, iterations }) {
  return Sjcl.codec.base64url.fromBits(Sjcl.misc.pbkdf2(password, Sjcl.codec.base64url.toBits(salt), iterations))
}



// WEBPACK FOOTER //
// ./src/core/key-derivation.js